export default __webpack_public_path__ + "static/media/regulatory--tanks-only--g1.46e2c223.png";